/**
 * All site copy in one place. Nothing here invents claims, clients,
 * statistics or achievements — only what the brief explicitly provided.
 */

export const identity = {
  name: 'Aymen Troudi',
  role: 'Founder & Software Engineer',
  ventures: ['ATR Business Solutions', 'Denora', 'LegalSnap'],
};

export const hero = {
  headline: 'I BUILD WHAT COMES NEXT.',
  sub: 'Founder and software engineer creating digital products, intelligent systems and scalable businesses.',
  founderLabel: 'FOUNDER OF ATR BUSINESS SOLUTIONS / DENORA / LEGALSNAP',
  ctaPrimary: 'EXPLORE MY WORK',
  ctaSecondary: "LET'S TALK",
};

export const founder = {
  eyebrow: 'THE FOUNDER',
  headline: 'I don’t simply write software.',
  body: 'I identify problems, design products, build systems and turn ideas into real digital businesses — across design, architecture, engineering, iteration, business and launch.',
};

export const atr = {
  eyebrow: 'THE COMPANY',
  headline: 'ATR BUSINESS SOLUTIONS',
  body: 'The business layer behind the products — where ideas become systems, and systems become companies.',
};

export const engineering = {
  eyebrow: 'THE SYSTEM',
  headline: 'BUILT FROM THE INSIDE.',
  body: 'Complex systems, made understandable — the technology underneath every product.',
  stack: [
    'React',
    'TypeScript',
    'JavaScript',
    'Node.js',
    'Go',
    'Java',
    'C#',
    'PostgreSQL',
    'MongoDB',
    'Docker',
    'Supabase',
    'Stripe',
    'SAP ABAP Cloud',
    'Three.js',
    'GSAP',
  ],
};

export const about = {
  eyebrow: 'BEHIND THE PRODUCTS',
  headline: 'BEHIND THE PRODUCTS.',
  body: 'Curiosity, product thinking, engineering, design, building and iteration — the founder behind ATR Business Solutions, Denora and LegalSnap.',
};

export const philosophy = {
  lineOne: 'IDEAS ARE EASY.',
  lineTwo: 'BUILDING THEM IS THE DIFFERENCE.',
};

export const contact = {
  headline: 'WHAT WILL WE BUILD NEXT?',
  body: 'Let’s turn an idea into something real.',
  ctaPrimary: "LET'S TALK",
  ctaSecondary: 'EXPLORE MY WORK',
  email: 'troudiaymen05@gmail.com',
};

export const nav = ['WORK', 'ABOUT', 'EXPERIENCE', 'CONTACT'] as const;
